import { IconProps } from '../../types/IconProps';

export const Cross = ({ variant, className }: IconProps) => {
  let fill;
  switch (variant) {
    case 'light':
      fill = '#fff';
      break;
    case 'dark':
      fill = '#0B223E';
      break;
    default:
      fill = 'currentColor';
  }
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      className={`${className || ''}`}>
      <path
        fill={fill}
        d='M19.182 6.414h-3.99v-3.99c0-.881-.715-1.596-1.596-1.596h-3.192c-.882 0-1.596.715-1.596 1.596v3.99h-3.99c-.882 0-1.596.715-1.596 1.596v3.192c0 .882.714 1.596 1.596 1.596h3.99v8.778c0 .881.714 1.596 1.596 1.596h3.192c.881 0 1.596-.715 1.596-1.596v-8.778h3.99c.881 0 1.596-.714 1.596-1.596V8.01c0-.881-.715-1.596-1.596-1.596Zm0 4.788h-4.788a.798.798 0 0 0-.798.798v9.576h-3.192V12a.798.798 0 0 0-.798-.798H4.818V8.01h4.788c.44 0 .798-.357.798-.798V2.424h3.192v4.788c0 .44.357.798.798.798h4.788v3.192Z'
      />
    </svg>
  );
};
